import React from "react";
import { Container } from "react-bootstrap";
import { render } from "react-dom";
import { Provider } from "react-redux";
import "whatwg-fetch";
import "./common/scss/main.scss";
import "./common/scss/modal.scss";
import "./common/fontawesome/scss/fontawesome.scss";
import "./common/fontawesome/scss/regular.scss";
import "./common/fontawesome/scss/solid.scss";
import Content from "./common/Content";
import { store } from "./redux/store/store";
export const globalStore = store;
import { Helmet } from "react-helmet";
import Footer from "./common/Footer";
import Feedback from "./common/Feedback";
import TopNavBar from "./common/TopNavBar";

interface AppProps
{
    name: string;
}

class App extends React.Component<AppProps>
{

    render(): React.ReactNode
    {
        return <div className="main-container">
            <Provider store={globalStore}>
                <TopNavBar title={"Canopy"} />
                <Feedback footer={false} />
                <Container>
                    <Helmet>
                        <html lang="en" ></html>
                    </Helmet>
                    <Content name={"Canopy"} />
                </Container>
                <Footer />
            </Provider>
        </div>;
    }
}

render(<App name={"Canopy"} />, document.getElementById("root"));
